module.exports = __webpack_public_path__ + "static/media/logo_square.4906bce9.svg";